import { render, staticRenderFns } from "./ListFaqCategory.vue?vue&type=template&id=354511c0&"
import script from "./ListFaqCategory.vue?vue&type=script&lang=js&"
export * from "./ListFaqCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports